import { render } from "./FeedbackForm.vue?vue&type=template&id=0f26352e"
import script from "./FeedbackForm.vue?vue&type=script&lang=js"
export * from "./FeedbackForm.vue?vue&type=script&lang=js"
script.render = render

export default script